import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/common/socialMediaLinkList.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import SocialMediaIcons from './SocialMediaIcons';

function SocialMediaLinkList({
	facebookLinkId = 'n/a',
	youtubeLinkId = 'n/a',
	discordLinkId = 'n/a',
	instagramLinkId = 'n/a',
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	const linkIds = {
		facebook: facebookLinkId,
		youtube: youtubeLinkId,
		instagram: instagramLinkId,
		discord: discordLinkId,
	};
	
	return (

		<div
			className={styles.socialMediaLinkList}
			data-testid="socialMediaLinkList">

			<SocialMediaIcons />

			{Object.keys(onelpsParams.socialMedia.links).map((socialMediaKey) => {
				return (
					<a
						key={socialMediaKey}
						href={onelpsParams.socialMedia.links[socialMediaKey].link}
						data-testid={onelpsParams.socialMedia.links[socialMediaKey].name}
						target="_blank"
						rel="noreferrer"
						id={linkIds[`${onelpsParams.socialMedia.links[socialMediaKey].name}`]}
						
					>
						<svg className={`social-icon-sprite icon-${onelpsParams.socialMedia.links[socialMediaKey].name}`}>
							<use xlinkHref={`#icon-${onelpsParams.socialMedia.links[socialMediaKey].name}`}></use>
						</svg>
					</a>
				);
			})}
		</div>
	);
}

SocialMediaLinkList.propTypes = {
	facebookLinkId: PropTypes.string,
	youtubeLinkId: PropTypes.string,
	discordLinkId: PropTypes.string,
	instagramLinkId: PropTypes.string,
};

export default SocialMediaLinkList;
